/*
* @Author: withease-partner+cao@hashdash-group.com 
 * @Description: the frame page of 「前面打沟的选择框」
 * @modify Date:2021-4-27 16:43
 */

<template>
  <div class="cCheckOption-container">
    <li
      v-for="(item, index) in selectdata"
      :key="index"
      @click="handelSelect(item)"
      class="select-item"
    >
      <img
        :src="
          item.isActive
            ? require('@/assets/img/right_square.svg')
            : require('@/assets/img/right_squareoff.svg')
        "
      />
      {{ item.value }}
    </li>
  </div>
</template>

<script>
export default {
  props: ['selectdata'],
  data() {
    return {};
  },
  watch: {},
  methods: {
    handelSelect(item) {
      this.$emit('selectClick', item);
    }
  }
};
</script>

<style lang='less' scoped>
.cCheckOption-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .select-item {
    cursor: pointer;
    width: 100%;
    font-size: 0.16rem;
    color: var(--text-blackcolor);
    display: flex;
    margin-bottom: 0.21rem;
    align-items: center;
    img {
      margin-right: 0.1rem;
      width: 0.24rem;
      height: 0.24rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Select/cCheckOption.vue